export const emptyOrderAnalysis = [
	{ label: 'TOTAL DELIVERED ORDERS', value: 0 },
	{ label: 'TOTAL PROCESSING ORDERS', value: 0 },
	{ label: 'TOTAL SHIPPED ORDERS', value: 0 },
];
